const FILENAME_STAR_PATTERN = /filename\*=(?:UTF-8'')?([^;]+)/i;
const FILENAME_PATTERN = /filename="?([^";]+)"?/i;

/**
 * Extracts the filename from a `Content-Disposition` header value, e.g.
 * `attachment; filename="aid-model-19-results-dataset-04-28-2026.csv"`.
 * Prefers the RFC 5987 `filename*` form (URL-encoded) when present, falling
 * back to the plain `filename` form. Returns `undefined` when the header is
 * missing or unparseable so callers can fall back to a default name.
 */
export const parseContentDispositionFilename = (
  contentDisposition: string | undefined | null
): string | undefined => {
  if (!contentDisposition) return undefined;

  const starMatch = contentDisposition.match(FILENAME_STAR_PATTERN);

  if (starMatch?.[1]) {
    try {
      return decodeURIComponent(starMatch[1].trim());
    } catch {
      return starMatch[1].trim();
    }
  }

  const match = contentDisposition.match(FILENAME_PATTERN);

  return match?.[1]?.trim() || undefined;
};
